export default __webpack_public_path__ + "static/media/post.ea6de7b9.svg";